@mixin mobileStyles {
  &.#{$prefix}mobile {
    position: relative;
    width: 100%;
    min-height: 49px;
    line-height: 24px;
    padding: 12px 48px 12px 32px;
    font-size: 18px;
    font-weight: 400;
    display: block;
    text-decoration: none;
    margin-bottom: 0px !important;
    outline: none !important;

    &.#{$prefix}large {
      position: relative;
      width: 100%;
      min-height: 49px;
      line-height: 24px;
      font-size: 18px;
      font-weight: 700;
    }

    &::before {
      content: "";
      position: absolute;
      left: 32px;
      top: 0;
      width: 100%;
      height: 1px;
      background-color: $navigation-mobile-link-border-color;
    }
  }

  &.#{$prefix}mobile {
    color: $navigation-mobile-link-font-color !important;
    background-color: transparent !important;

    eon-ui-icon {
      color: $navigation-mobile-link-font-color !important;
    }
  }
}

:host {
  display: block;
  margin-bottom: 12px !important;
}

:host([mobile]) {
  margin-bottom: 0px !important;
}

a {
  position: relative;
  height: 100%;
  font-family: $font-family-base;
  font-size: 18px;
  line-height: 24px;
  color: $navigation-flyout-link-font-color;
  text-decoration: none;
  display: inline-block;
  box-sizing: border-box;
  cursor: pointer;

  &.#{$prefix}large {
    color: $navigation-flyout-link-large-font-color;
    font-size: 22px;
    font-weight: bold;
    opacity: 1;
  }

  &:hover {
    color: $navigation-flyout-link-font-color-hover;
    text-decoration: underline;

    &.#{$prefix}large {
      color: $navigation-flyout-link-large-font-color-hover;
    }
  }

  &:focus {
    color: $navigation-flyout-link-font-color-focus;
    outline: 1px solid;
    outline-offset: 4px;
    outline-color: $navigation-flyout-link-font-color-focus;

    &.#{$prefix}large {
      color: $navigation-flyout-link-large-font-color-focus;
      outline-color: $navigation-flyout-link-large-font-color-focus;
    }
  }

  &.#{$prefix}current {
    color: $navigation-flyout-link-font-color-current;

    &::after {
      content: "";
      position: absolute;
      left: -16px;
      top: 0;
      width: 4px;
      height: 24px;
      background-color: $navigation-flyout-link-border-color-current;
    }

    @include for-size(tablet-or-smaller) {
      &::after {
        left: 0;
        height: 100%;
      }
    }

    &.#{$prefix}large {
      color: $navigation-flyout-link-large-font-color-current;

      &::after {
        background-color: $navigation-flyout-link-large-border-color-current;
      }
    }
  }

  @include mobileStyles;
}

span {
  position: relative;
  height: 100%;
  font-family: $font-family-base;
  font-size: 18px;
  line-height: 24px;
  color: $navigation-flyout-link-font-color;
  display: inline-block;
  box-sizing: border-box;

  &.#{$prefix}large {
    font-size: 22px;
    font-weight: bold;
  }

  @include mobileStyles;
}
